import {useEffect} from 'react';

import {config} from '../config';
import {toClientCallType} from '../utils/toClientCallTypes';
import {getIsMeetingManagerPath} from '../utils/getIsMeetingManagerPath';

export const useMeetingManagerConfig = () => {
    useEffect(() => {
        const isMeetingManagerPath = getIsMeetingManagerPath();
        if (isMeetingManagerPath) {
            config.set({key: 'callType', value: toClientCallType('none')});
            config.set({
                key: 'callTypeQueryParameter',
                value: 'none',
            });
            config.set({key: 'join', value: true});
        }
    }, []);
};
